import { IOptionItemProps } from '../../../../../components/common/Select/Select';
import { IFormAddressField } from '../../../../../modules/formAddress/types/formAddressTypes';
import { TAvailableActions } from '../../../../../types/globalTypes';
import { ESubscriberIdActions } from '../../../types';


export interface IPersonalDataMeta {
    actions: TAvailableActions<ESubscriberIdActions>;
    docTypes: { [id: string]: IPersonalDataDocType };
    maxFileAmount: number;
    maxFileSize: number;
    options: IOptionItemProps[];
    passportId: number;
    personalDataTypes: IPersonalDataPersonalDataType;
}

export interface IPersonalDataPersonalDataType {
    documentAttributes: PersonalDataType[];          // Список доступных атрибутов для перс данных
    mandatoryAttributes: PersonalDataType[];         // Список обязательных атрибутов для перс данных
}

export interface IPersonalDataDocType {
    id: number;                                         // Идентификатор типа документа
    name: string;                                       // Наименование типа документа
    mandatoryAttributes: PersonalDataType[];            // Список обязательных атрибутов для документа
    documentAttributes: PersonalDataType[];             // Список доступных атрибутов для документа
    seriesRegExp?: string;                              // Регулярное выражение для проверки серии документа
    numRegExp?: string;                                 // Регулярное выражение для проверки номера документа
    isResident: boolean;                                // Признак документа, определяющего резиденство
    nationalityInfo?: IFormAddressField;                // Страна резиденства для документа
}

export enum PersonalDataType {
    address = 'address',
    // personal data
    birthDate = 'birthDate',
    birthPlace = 'birthPlace',
    email = 'email',
    name = 'name',
    nationalityInfo = 'nationalityInfo',
    patronymic = 'patronymic',
    surname = 'surname',
    // doc
    dateOfIssue = 'dateOfIssue',
    divisionCode = 'divisionCode',
    number = 'number',
    providedByOrganization = 'providedByOrganization',
    series = 'series',
    type = 'type',
    validFor = 'validFor',
    // file
    files = 'files',
}
